import { Component, inject } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ToastService } from '../../services/toast.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [SvgIconComponent, NgClass],
  templateUrl: './toast.component.html',
  styles: ``
})
export class ToastComponent {
  public toastService = inject(ToastService);

  public remove(id: number): void {
    this.toastService.remove(id);
  }
}
